import { useRef, useState, useEffect } from "react";
import { isSet } from "../../../utils/commonUtils";
import { OK } from "../../../utils/constant";
// import ChartingSection from ".././Tabs/EmrPages/ChartingSection";
import NotesAlerts from "../Tabs/ChartNotesTabs/NotesAlerts";
import ImagesTab from "../Tabs/ChartNotesTabs/ImagesTab";
import ConfidentialNotes from "../Tabs/ChartNotesTabs/ConfidentialNotes";
import AssesmentTab from "../Tabs/AssesmentTab/AssesmentTab";
import HeaderSection from "./HeaderSection";
import SubTabSection from "./SubTabSection";
import AbormalFindingsSection from "./AbormalFindingsSection";
import WithRouter from "../../../hoc/WithRouter";
import EmrConfigService from "../../../services/EmrConfigService";
import ChartNote from "../Tabs/ChartNotesTabs/ChartNote";
import FormsTab from "../Tabs/ChartNotesTabs/FormsTab";
import ChartingSection from "./ChartingSection";
import ProgressNote from "../ProgressNote";
import WorkRestrictionsTab from "../Tabs/WorkRestrictionsTab";
import NewAssesmentTab from "../Tabs/AssesmentTab/NewAssesmentTab";
import VitalsTab from "../Tabs/Vitals/VitalsTab";
import OrdersAndResultsSection from "../Tabs/OrdersAndResultsSection/OrdersAndResultsSection";
import ComplaintPage from "../Tabs/ComplaintPage/ComplaintPage";
import AllOrdersPage from "../Tabs/OrdersAndResultsSection/AllOrdersPage"
import EditChartNote from "../Tabs/ChartNotesTabs/EditChartNote";
import Alert from "../../../components/UI/ConfirmBox/Alert";
import ReferalsPage from "../Tabs/ReferralsTab/ReferalsPage";
import WorkStatusPage from "../Tabs/WorkStatusTab/WorkStatusPage";
import PrescribedMedicationsPage from "../Tabs/PrescribedMedicationsTab/PrescribedMedicationsPage";
import ActivityChargesList from "./ActivityChargesList";
import NewEditChartNote from "../Tabs/ChartNotesTabs/NewEditChartNote";
import HistoryRecapSection from "./HistoryRecapSection";
import SchoolNoteTab from "../Tabs/SchoolNoteTab/SchoolNote";
import TranscriptionRecordingModal from "../../EmployeeVisitContainer/NewUIVisitList/TranscriptionRecordingModal";
import { RxntPrescriptionsPage } from "../Tabs/RxntTab";
const NewRightContent = ({
  visit_id,
  employeeId,
  Toast,
  Loader,
  visitDetails,
  employeeDetails,
  fetchEmployeeDetails,
  params,
  visit_status,
  setVisitStatus,
  incidentDetails, // <-- ADDED: Destructure the new prop
  onHpiSaved,
  assessmentRefreshTrigger, // Trigger to refresh assessment
  onDiagnosisRemoved, // Callback when diagnosis is removed
  profile,
  isLeftSidebarCollapsed,
  ...props
}) => {
const [Headers, setHeaders] = useState({});
const [scrollTab,setScrollTab]=useState("progressNote")
const selectedSubTabRef = useRef(null);
  /** After opening EMR from `?activityMappingId=`, visitDetails refetches when URL is cleared; skip snapping back to Complaint. */
  const suppressDefaultEmrTabAfterActivityDeepLinkRef = useRef(false);

  useEffect(() => {
    suppressDefaultEmrTabAfterActivityDeepLinkRef.current = false;
  }, [visit_id]);

useEffect(() => {
  const visitCategory = visitDetails["0"]?.visit_category;
  if (!visitCategory) return;
  fetchTabsList()
  // Use screen_type if available, otherwise fall back to visit_category
  const categoryForCheck = visitDetails["0"]?.screen_type || visitCategory;
  const newHeaders = categoryForCheck === "Work Comp - Physical Therapy"
    ? {
        Subjective: [
        { label: "Complaint", apikey: "SUBJECTIVE_COMPLAINT", component: ChartingSection },
        { label: "HPI", apikey: "SUBJECTIVE_HPI", component: ChartingSection },
        { label: "PMH", apikey: "SUBJECTIVE_PMH", component: ChartingSection },
        { label: "ROS", apikey: "SUBJECTIVE_ROS", component: ChartingSection },
        ],
        Objective: [
          { label: "ROM / Tests", apikey: "SOAP_ROM_TESTS", component: ChartingSection },
          { label: "Exercise", apikey: "SOAP_EXERCISE", component: ChartingSection },
          { label: "Reeducation", apikey: "SOAP_REEDUCATION", component: ChartingSection },
          { label: "Activities", apikey: "SOAP_ACTIVITIES", component: ChartingSection },
          { label: "Modalities", apikey: "SOAP_MODALITIES", component: ChartingSection },
        ],
        Assessment: [{ label: "Assessment", apikey: "SOAP_ASSESSMENT", component: ChartingSection }],
        Plan: [{ label: "Plan", apikey: "SOAP_PLAN", component: ChartingSection }],
        "Chart by Superbill": [
          { label: "Work Restrictions", apikey: "WORK_RESTRICTIONS", component: WorkRestrictionsTab },
          { label: "School Note", apikey: "SCHOOL_NOTE", component: ChartingSection },
          { label: "Return/FollowUp", apikey: "RETURN_FOLLOWUP", component: ChartingSection },
          { label: "Forms", apikey: "FORMS", component: ChartingSection },
          { label: "Referrals", apikey: "REFFERALS", component: ChartingSection },
        ],
        "Chart Note": [
          { label: "Forms", apikey: "FORMS", component: FormsTab },
          { label: "Images", apikey: "IMAGES", component: ImagesTab },
          { label: "Chart Notes", apikey: "CHART_NOTES", component: ChartNote },
          { label: "Notes & Alerts", apikey: "ALERT_NOTES", component: NotesAlerts },
          { label: "Confidential Notes", apikey: "CONFIDENTIAL_NOTES", component: ConfidentialNotes },
        ],
        "Super Dictation": [
          { label: "Chart by Superbill", apikey: "PHYSICAL_THERAPY_BY_SUPERBILL", component: ChartingSection },
          { label: "Chart by Dictation", apikey: "PHYSICAL_THERAPY_BY_DICTATION", component: ChartingSection },
        ],
      }
    : {
      Complaint: [
        { label: "Complaint", apikey: "COMPLAINT", component: ChartingSection },
        { label: "Vitals", apikey: "VITALS", component: VitalsTab }
      ],
        History: [
          { label: "HPI", apikey: "HPI", component: ChartingSection },
          { label: "PMH", apikey: "PMH", component: ChartingSection },
          { label: "ROS", apikey: "ROS", component: ChartingSection },
        ],
        Examination: [
          { label: "Musculoskeletal", apikey: "MUSCULOSKELETAL", component: ChartingSection },
          { label: "Organ Systems", apikey: "ORGAN_SYSTEMS", component: ChartingSection },
          { label: "Problem Focused - Illness", apikey: "PROBLEM_FOCUSED_ILLNESS", component: ChartingSection },
          { label: "Problem Focused - Injury", apikey: "PROBLEM_FOCUSED_INJURY", component: ChartingSection },
          { label: "Lacerations", apikey: "EXAMINATION_LACERATIONS", component: ChartingSection },
        ],
        "Order/Results": [
           { label: "ALL",apikey:"ALL", component: AllOrdersPage },
          { label: "X-ray", apikey: "X_RAY", component: ChartingSection },
          // { label: "Lab / Diagnostic", apikey: "LAB_DIAGNOSTIC", component: ChartingSection },
          { label: "Labs", apikey: "LAB", component: ChartingSection },
          { label: "Diagnostics", apikey: "DIAGNOSTIC", component: ChartingSection },
          { label: "Treatments", apikey: "TREATMENTS", component: ChartingSection },
          { label: "Inject / Vaccines", apikey: "INJECT_VACCINES", component: ChartingSection },
          { label: "Prescriptions", apikey: "PRESCRIPTIONS", component: ChartingSection },
          { label: "DMEs", apikey: "DMES", component: ChartingSection },
          { label: "Referrals", apikey: "REFERRALS", component: ChartingSection },
        ],
        Assessment: [{ label: "Assessment", apikey: "ASSESSMENT", component: NewAssesmentTab }],
        Procedures: [
          { label: "Lacerations", apikey: "PROCEDURES_LACERATIONS", component: ChartingSection },
          { label: "Other Procedures", apikey: "OTHER_PROCEDURES", component: ChartingSection },
        ],
        "Discharge": [
          { label: "Work Restrictions", apikey: "WORK_RESTRICTIONS", component: WorkRestrictionsTab },
          { label: "School Note", apikey: "SCHOOL_NOTE", component: SchoolNoteTab },
          { label: "Return/FollowUp", apikey: "RETURN_FOLLOWUP", component: ChartingSection },
          { label: "Forms", apikey: "FORMS", component: FormsTab },
          { label: "Referrals", apikey: "REFFERALS", component: ChartingSection },
        ],
        "Chart Note": [
          { label: "Forms", apikey: "FORMS", component: FormsTab },
          { label: "Images", apikey: "IMAGES", component: ImagesTab },
          { label: "Chart Notes", apikey: "CHART_NOTES", component: ChartNote },
          { label: "Notes & Alerts", apikey: "ALERT_NOTES", component: NotesAlerts },
          { label: "Confidential Notes", apikey: "CONFIDENTIAL_NOTES", component: ConfidentialNotes },
        ],
        "Super Dictation": [
          { label: "Chart by Superbill", apikey: "CHART_BY_SUPERBILL", component: ChartingSection },
          { label: "Chart by Dictation", apikey: "CHART_BY_DICTATION", component: ChartingSection },
        ],
      };

  // setHeaders(newHeaders);
  const defaultTab = categoryForCheck === "Work Comp - Physical Therapy" ? "Subjective" : "Complaint";
  const searchParams = new URLSearchParams(props.location?.search || "");
  const hasActivityMappingInUrl = !!(
    searchParams.get("activityMappingId") ||
    searchParams.get("activity_mapping_id")
  );

  if (hasActivityMappingInUrl) {
    suppressDefaultEmrTabAfterActivityDeepLinkRef.current = true;
    setSelectedTab("Order/Results");
    setSelectedSubTab("ALL");
    return;
  }

  // When visitDetails updates (e.g. after attestation save), stay on History Recap if user is there
  if (selectedSubTabRef.current === "HISTORY_RECAP") return;

  if (suppressDefaultEmrTabAfterActivityDeepLinkRef.current) {
    return;
  }

  setSelectedTab(defaultTab);
  setSelectedSubTab(newHeaders[defaultTab]?.[0]?.apikey || "");
}, [visitDetails]);

  const [selectedTab, setSelectedTab] = useState("Order/Results");
  const [selectedSubTab, setSelectedSubTab] = useState(
    Headers[selectedTab]?.[0]?.apikey || ""
  );

  useEffect(() => {
    selectedSubTabRef.current = selectedSubTab;
  }, [selectedSubTab]);

  // Keep Charges active for ALL orders; default back to Progress Note for charting subtabs
  useEffect(() => {
    if (selectedSubTab === 'ALL') {
      setScrollTab('history');
    } else {
      setScrollTab('progressNote');
    }
  }, [selectedSubTab]);

  const [expandedSection, setExpandedSection] = useState(null);
  const [inactiveLeft, setInactiveLeft] = useState(true);
  const [progressNote, setProgressNote] = useState("");
  const scrollerRef = useRef(null);
  const [finishedTabs,SetFinishedTabs]=useState([])
  const [tabData,setTabData]=useState([])
  const [finishedSubTabs,SetFinishedSubTabs]=useState([])
  const [isChartingSectionDirty, setIsChartingSectionDirty] = useState(false)
  const [showUnsavedAlert, setShowUnsavedAlert] = useState(false);
  const [pendingCallback, setPendingCallback] = useState(null);
  const [refreshEmrTrigger, setRefreshEmrTrigger] = useState(0);
  const [showTranscriptionModal, setShowTranscriptionModal] = useState(false);
  useEffect(() => {
    // const checkScroller = () => {
    //   setInactiveLeft(scrollerRef.current.scrollLeft === 0);
    // };

    // const handleScroll = () => {
    //   setInactiveLeft(scrollerRef.current.scrollLeft === 0);
    // };

    // checkScroller();
    // if (scrollerRef.current) {
    //   scrollerRef.current.addEventListener("scroll", handleScroll);
    // }

    // return () => {
    //   if (scrollerRef.current) {
    //     scrollerRef.current.removeEventListener("scroll", handleScroll);
    //   }
    // };
  }, []);
  // Function to handle unsaved changes check
  const checkUnsavedChanges = (callback) => {
    console.log("isChartingSectionDirty in checkUnsavedChanges:", isChartingSectionDirty);
    if (isChartingSectionDirty) {
      // Instead of window.confirm(), show custom modal
      setPendingCallback(() => callback);
      setShowUnsavedAlert(true);
      return true; // temporarily block navigation until user confirms
    }
    callback(); // No unsaved changes
    return false;
  };

  // const handleProceed = () => {
  //   setIsChartingSectionDirty(false);
  //   setShowUnsavedAlert(false);
  //   if (pendingCallback) pendingCallback();
  //   setPendingCallback(null);
  // };
  
  // const handleCancel = () => {
  //   setShowUnsavedAlert(false);
  //   setPendingCallback(null);
  // };
  
  
  const fetchTabsList= async () => {
    try{
      Loader(true);
        const visitCategory = visitDetails["0"]?.visit_category;
       const response = await EmrConfigService.getTabsList(visit_id,visitCategory)
      if(response){
         const result = {};
         const completedTab=[]
         const completedsubtabs=[]
         response.forEach(tab => {
          const tabKey = tab.tab_name;
          if(tab.tab_status==='COMPLETED'){
            completedTab.push(tab.tab_name)
          }
          result[tabKey] = tab[tabKey].map(sub => {
            if(sub.sub_tab_status==='COMPLETED'){
              completedsubtabs.push(sub.apikey)
            }
            let component = ChartingSection; // default
            // override for special apikeys if needed
            switch (sub.apikey) {
              case "FORMS":
                component = FormsTab;
                break;
              case "IMAGES":
                component = ImagesTab;
                break;
              case "CHART_NOTES":
                component = ChartNote;
                break;
              case "ALERT_NOTES":
                component = NotesAlerts;
                break;
              case "CONFIDENTIAL_NOTES":
                component = ConfidentialNotes;
                break;
              case "ASSESSMENT": // different component for some flows
                component = NewAssesmentTab;
                break;
              case "WORK_RESTRICTIONS":
                component = WorkRestrictionsTab;
                break;  
              case 'VITALS':
                component= VitalsTab;
                break ;
              case "COMPLAINT":
                  component = ComplaintPage;
                  break;
              case "HISTORY_RECAP":
                  component = HistoryRecapSection;
                  break;
              case "SCHOOL_NOTE":
                component = SchoolNoteTab;
                break;
              case "ALL":
                    component = AllOrdersPage;  
                    break;
                    case "EDIT_CHART_NOTES":
                      // component = EditChartNote;
                      component = NewEditChartNote;
                      break;
                      case "REFERRALS":
                        component = ReferalsPage;
                        break;
                      case "WORK_STATUS":
                        component = WorkStatusPage;
                        break;
                      case "PRESCRIBED_MEDICATIONS":
                        component = PrescribedMedicationsPage;
                        break;
                      case "RXNT_EPRESCRIPTIONS":
                        component = RxntPrescriptionsPage;
                        break;
              default:
                component = ChartingSection;
            }
            return {
              label: sub.label,
              apikey: sub.apikey,
              component,
            };
          });
        });
        
        setHeaders(result);
        SetFinishedTabs(completedTab)        
        SetFinishedSubTabs(completedsubtabs)
        setTabData(response)

      }       
    }catch(err){

    }finally{
      Loader(false);
    }
  }
  const fetchProgressNotesByScreen = async () => {
    Loader(true);
    try {
      const response = await EmrConfigService.visifetchProgressData(
        visit_id,
        selectedSubTab
      );
      Loader(false);
      if (response.code !== OK) {
        console.error("API response not successful:", response);
        return false;
      }
      const data = response.data || {};
      const display_value = data.display_value ?? null;
      setProgressNote(isSet(display_value, ""));
    } catch (err) {
      console.error("Error fetching progress data:", err);
      Loader(false);
    }
  };

  const updateProgress = async (visit_id, data) => {
    try {
      const payload = {
        displayText: data,
      };
      const response = await EmrConfigService.upateProcessData(
        visit_id,
        selectedSubTab,
        payload
      );

      if (data === " ") {
        Toast.success(" Data Cleared");
      } else {
        Toast.success("Data Updated ");
      }
      await fetchProgressNotesByScreen();
    } catch (error) {
      console.error("Failed to update progress data :", error);
    }
  };

  const handleRightClick = () => {
    scrollerRef.current.scrollBy({ left: 200, behavior: "smooth" });
  };

  const handleLeftClick = () => {
    scrollerRef.current.scrollBy({ left: -200, behavior: "smooth" });
  };

  const handleTabClick = (label, index) => { // <--- MODIFIED
    const blocked = checkUnsavedChanges(() => {
        setSelectedTab(label);
        setSelectedSubTab(Headers[label]?.[0]?.apikey || "");
        setExpandedSection(null);
    });
    if (!blocked) {
        // ... (any other logic after tab change)
    }
};

const handleSubTabClick = (apikey) => { // <--- MODIFIED
    checkUnsavedChanges(() => {
        setSelectedSubTab(apikey);
        setExpandedSection(null);
    });
};
  const tabHeaders = Headers[selectedTab] || [];
  const SelectedComponent = tabHeaders.find(
    (header) => header?.apikey === selectedSubTab
  );
 const visitCategory = visitDetails["0"]?.visit_category;
 const isEmrReady = Object.keys(Headers).length > 0;
  return (
    <>
    <div className={`px-2 sh_emrMainContentWrap ${isLeftSidebarCollapsed ? "sh_emrMainContentWrapExpanded" : ""}`}>
      <div className="sh_cardBox h-100 sh_cardbglight">
        <div className="sh_cardBody">
          <div className="d-flex sh_emrresponsivegridbox">
            <HeaderSection
              handleLeftClick={handleLeftClick}
              handleRightClick={handleRightClick}
              tabHeaders={Object.keys(Headers).map((key) => ({label: key,}))}
              selectedTab={selectedTab}
              handleTabClick={handleTabClick}
              finishedTabs={finishedTabs}
              scrollerRef={scrollerRef}
              inactiveLeft={inactiveLeft}
              params={params} />
            <div className="d-flex sh_emrresponsivegridright" style={{'width':'90%'}}>
              <div className="sh_cardBox h-auto w-100">
                <SubTabSection
                  subTabs={Headers[selectedTab] || []}
                  selectedSubTab={selectedSubTab}
                  selectedTab={selectedTab}
                  onSubTabClick={handleSubTabClick} 
                  finishedSubTabs={finishedSubTabs}
                  finishedTabs={finishedTabs}
                  tabHeaders={Object.keys(Headers).map((key) => ({label: key,}))}
                  visit_status={visit_status}
                  setVisitStatus={setVisitStatus}
                  visitId={visit_id}
                  visitDetails={visitDetails}
                  Loader={Loader}
                  Toast={Toast}
                  profile={profile}
                  getIncidentById={props.getIncidentById}
                  refreshEmrFields={() => setRefreshEmrTrigger(prev => prev + 1)}
                  fetchTabsList={fetchTabsList}
                  onOpenVoiceTranscription={() => {
                    if (visit_id) setShowTranscriptionModal(true);
                  }}
                  />
                  <div>
                <div class="sh_cardBody">
                  {SelectedComponent?.component && (
                    <SelectedComponent.component
                      subTabs={Headers[selectedTab] || []}
                      selectedSubTab={selectedSubTab}
                      visit_id={visit_id}
                      setExpandedSection={setExpandedSection}
                      fetchProgressNotesByScreen={()=>fetchProgressNotesByScreen()}
                      Loader={Loader}
                      Toast={Toast}
                      employeeId={employeeId}
                      employeeDetails={employeeDetails}
                      fetchEmployeeDetails={fetchEmployeeDetails} 
                      expandedSection={expandedSection}
                      selectedTab={selectedTab}
                      setSelectedSubTab={setSelectedSubTab}
                      selectedBodyPart={props.selectedBodyPart}
                      setSelecetedBodyParts={props.setSelecetedBodyParts}
                      isrenderICD={props.isrenderICD}
                      isrenderIncident={props.isrenderIncident}
                      SetFinishedTabs={SetFinishedTabs}
                      fetchTabsList={fetchTabsList}
                      tabData={tabData}
                      finishedSubTabs={finishedSubTabs}
                      finishedTabs={finishedTabs}
                      SetFinishedSubTabs={SetFinishedSubTabs}
                      VISITCATEGORY={visitCategory}
                      ToggleOrders={props.ToggleOrders}
                      addVaccineToogleHandler={props.addVaccineToogleHandler}
                      visitDetails={visitDetails}
                      setIsChartingSectionDirty={setIsChartingSectionDirty}
                      isChartingSectionDirty={isChartingSectionDirty}
                      showUnsavedAlert={showUnsavedAlert}
                      setShowUnsavedAlert={setShowUnsavedAlert}
                      pendingCallback={pendingCallback}
                      setPendingCallback={setPendingCallback}
                      checkUnsavedChanges={checkUnsavedChanges}
                      incidentDetails={incidentDetails} // <-- ADDED: Pass the prop to the rendered component
                      getIncidentById={props.getIncidentById} // <-- ADDED: Pass getIncidentById to fetch incident details
                      refreshEmrTrigger={refreshEmrTrigger}
                      refreshEmrFields={() => setRefreshEmrTrigger(prev => prev + 1)}
                      onHpiSaved={onHpiSaved}
                      assessmentRefreshTrigger={assessmentRefreshTrigger} // Pass trigger to assessment tab
                      onDiagnosisRemoved={onDiagnosisRemoved} // Pass callback for when diagnosis is removed
                      profile={profile}
                      fetchVisitList={props.fetchVisitList}
                      onOpenVoiceTranscription={() => {
                        if (visit_id) setShowTranscriptionModal(true);
                      }}
                    />)}
                  {/* <ChartingSection /> */}
                  {isEmrReady &&
                    selectedTab !== "Order/Results" &&
                    !['VITALS','CHART_NOTES','IMAGES','ALERT_NOTES','CONFIDENTIAL_NOTES','COMPLAINT','EDIT_CHART_NOTES','WORK_STATUS','PRESCRIBED_MEDICATIONS','HISTORY_RECAP'].includes(selectedSubTab) && (
                    <div className="sh_cardBox">
                    <div className="sh_cardHeader">
                      <div className="tabs_wrapForTable">
                      <ul className="nav  sh_subnav border-0" ref={scrollerRef}>
                        {selectedSubTab !== 'ALL' && (
                          <li><a class={`nav-link  cursor-pointer  text-sm-center ${scrollTab==='progressNote'?'active':''}`} data-bs-toggle="tab" onClick={()=>setScrollTab("progressNote")}>Progress Note</a></li>
                        )}
                       { !["Chart Note"].includes(
                          selectedTab
                        ) && ( <li><a class={`nav-link cursor-pointer text-sm-center ${scrollTab==='history'?'active':''} `} data-bs-toggle="tab" onClick={()=>setScrollTab("history")} >Charges</a></li>)}
                      </ul>
                      </div>
                    </div>
                    <div className="sh_cardBody">
                     {scrollTab==='history'? 
                      <div className="row">
                        {/* <AbormalFindingsSection visit_id={visit_id} Headers={Headers} selectedTab={selectedTab}/> */}
                       <ActivityChargesList visit_id={visit_id} Headers={Headers} selectedTab={selectedTab} Toast={Toast}/>
                        {/* <OrdersAndResultsSection visit_id={visit_id} addVaccineToogleHandler={props.addVaccineToogleHandler} ToggleOrders={props.ToggleOrders} renderResults={props.renderResults} setActiveEditId={props.setActiveEditId} activeEditId={props.activeEditId} /> */}
                      </div>
                        : selectedSubTab !== 'ALL' && !["Chart Note"].includes(
                          selectedTab
                        ) && (
                          <div className="row">
                            <ProgressNote
                              updateProgress={updateProgress}
                              progressNote={progressNote}
                              visit_id={visit_id}
                              setProgressNote={setProgressNote} />
                          </div>)}
                    </div>
                  </div>
                  )}
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* {showUnsavedAlert && (
  <Alert
    contentTitle="You have unsaved changes. Are you sure you want to navigate away? Changes will be lost."
    content="You have unsaved changes. Are you sure you want to navigate away? Changes will be lost."
    yesButtonName="Discard"
    noButtonName="Cancel"
    type="warning"
    onDelete={handleProceed}   // ✅ Proceed
    onClose={handleCancel}     // ❌ Cancel
    confirmButtonClassName="btn btn-danger"
    cancelButtonClassName="btn btn-secondary"
  />
)} */}

      <TranscriptionRecordingModal
        isOpen={showTranscriptionModal && !!visit_id}
        visitId={visit_id}
        visitData={visitDetails}
        profile={profile}
        onClose={() => setShowTranscriptionModal(false)}
        Toast={Toast}
        Loader={Loader}
      />
    </>
  );
};

export default WithRouter(NewRightContent);
